export default "__VITE_ASSET__a281b91c__"